import React from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";

import { Modal } from "../../common/modal";
import Input from "../../common/input";
import TextArea from "../../common/textarea";
import ModalControl from "../../modalControl";
import styles from "./messageModal.module.css";
import { phone as phoneRegex } from "../../../constants/regex";
import { OverlayPreloader } from "../../common/preloader";

const MessageModal = ({ closeModal, onSubmit, listingName, defaultValue, loading }) => {
  const { t } = useTranslation();

  const validate = values => {
    const { fullName, phone, message } = values;
    const errors = {};
    const requiredText = t("dashboard_form_validations_password_required");

    if (!fullName) {
      errors.phone = requiredText;
    }

    if (!phone) {
      errors.phone = requiredText;
    }

    if (phone && !phone.match(phoneRegex)) {
      errors.phone = t("dashboard_form_validations_invalid_phone");
    }

    if (!message) {
      errors.message = requiredText;
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      fullName: defaultValue.fullName,
      phone: defaultValue.phone,
      message: ""
    },
    validate,
    onSubmit: values => {
      onSubmit(values);
    }
  });

  const { errors, values, setFieldValue, handleSubmit } = formik;

  const handleChange = event => {
    setFieldValue(event.target.name, event.target.value);
  };

  return (
    <Modal classNameMain={styles.modal} clearAllModals={closeModal} closeModal={closeModal}>
      {loading && <OverlayPreloader />}

      <h1 className={styles.title}>Message to {listingName}</h1>

      <Input
        label="Your Full Name"
        name="fullName"
        required
        isInvalid={errors.fullName}
        error={errors.fullName}
        value={values.fullName}
        onChange={handleChange}
        classNameWrap={styles.inputWrap}
      />

      <Input
        label="Your Phone Number"
        name="phone"
        required
        isInvalid={errors.phone}
        error={errors.phone}
        value={values.phone}
        onChange={handleChange}
        classNameWrap={styles.inputWrap}
      />

      <TextArea
        label="Your Message"
        required
        name="message"
        value={values.message}
        isInvalid={errors.message}
        error={errors.message}
        onChange={handleChange}
        classNameWrap={styles.inputWrap}
        className={styles.textarea}
      />

      <ModalControl onConfirm={handleSubmit} isHideExit confirmClassName={styles.button}>
        {t("dashboard_common_button_next")}
      </ModalControl>
    </Modal>
  );
};

export default MessageModal;
